export interface IRaceGenderGraphHeadings {
  race: string;
  gender: string;
  shortCode: string;
}

export const raceGenderConfigs: IRaceGenderGraphHeadings[] = [
  { race: 'African', gender: 'Male', shortCode: 'AM' },
  { race: 'African', gender: 'Female', shortCode: 'AF' },
  { race: 'Coloured', gender: 'Male', shortCode: 'CM' },
  { race: 'Coloured', gender: 'Female', shortCode: 'CF' },
  { race: 'Indian', gender: 'Male', shortCode: 'IM' },
  { race: 'Indian', gender: 'Female', shortCode: 'IF' },
  { race: 'White', gender: 'Male', shortCode: 'WM' },
  { race: 'White', gender: 'Female', shortCode: 'WF' },
  { race: 'Foreign National', gender: 'Male', shortCode: 'FNM' },
  { race: 'Foreign National', gender: 'Female', shortCode: 'FNF' },
];
